/* @jsx h */
import { defineComponent, h } from "vue";
import type { TerminalProvider } from "@lemmonhq/types";
import { getTerminalProviderConfig } from "./providerConfig";

type ProviderLogoProps = {
  provider: TerminalProvider | null | undefined;
  size?: "sm" | "md";
};

/** Provider logo on a white tile (logos are drawn for light backgrounds). */
export const ProviderLogo = defineComponent<ProviderLogoProps>({
  name: "TerminalProviderLogo",
  props: ["provider", "size"],
  setup(props) {
    return () => {
      const config = getTerminalProviderConfig(props.provider || "nakka");
      const box = props.size === "sm" ? "h-9 w-9 p-1.5" : "h-11 w-11 p-2";
      return config.logo ? (
        <div
          class={`flex shrink-0 items-center justify-center rounded-lg bg-white ${box}`}
        >
          <img
            src={config.logo}
            alt={config.label}
            class="h-full w-full object-contain"
          />
        </div>
      ) : (
        <div
          class={`flex shrink-0 items-center justify-center rounded-lg bg-primary/10 ${box}`}
        >
          <span class="material-symbols-outlined text-primary">
            {config.icon}
          </span>
        </div>
      );
    };
  },
});
